import type { GuideHeading } from "../lib/article";

type TableOfContentsProps = {
  headings: readonly GuideHeading[];
};

export function TableOfContents({ headings }: TableOfContentsProps) {
  if (headings.length === 0) return null;
  return (
    <nav className="toc" aria-label="In this guide">
      <p className="toc__title">In this guide</p>
      <ol className="toc__list">
        {headings.map((heading) => (
          <li className={`toc__item toc__item--level-${heading.level}`} key={heading.id}>
            <a href={`#${heading.id}`}>{heading.text}</a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
